import { render, staticRenderFns } from "./NewPasswordBox.vue?vue&type=template&id=052b1392"
import script from "./NewPasswordBox.vue?vue&type=script&lang=js"
export * from "./NewPasswordBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports